import React from 'react';
import { Link } from 'react-router-dom';
import heroLogo from '../assets/logos/merchmint-hero-transparent.png';

// Placeholder product data - replace with real images later
const products = [
  {
    id: 1,
    name: 'Custom T-Shirts',
    description: 'High-quality custom printed tees',
    price: 'We have great relationships with National and New Orleans printers. Let us advise what print process you want! Let us help you extend your brand with your custom T-Shirts (or jerseys, totes, shorts, socks, and anything you can think of).',
    image: '/images/clients/shirt.png',
  },
  {
    id: 2,
    name: 'Vinyl Records',
    description: 'Established connections with record presses that are affordable and high quality. Whether its a simple black vinyl, or a picture disc, we can facilitate it all. We can even coordinate with your record label if needed. We\u2019re here to simplify your life and create things fans love.',
    price: 'From $12',
    image: '/images/clients/freedia-album.png',
  },
  {
    id: 3,
    name: 'Art Prints',
    description: 'Theres nothing quite like a unique poster, print, or lithograph that fans will love. We work with trusted printers and designers to let your fans bring home a piece of their favorite artist',
    price: 'From $20',
    image: '/images/clients/tank-art.jpg',
  },
  {
    id: 4,
    name: 'Books & Zines',
    description: 'Custom publishing solutions',
    price: 'From $8',
    image: 'https://images.unsplash.com/photo-1544947950-fa07a98d237f?w=400&h=400&fit=crop',
  },
  {
    id: 5,
    name: 'Greeting Cards',
    description: 'Custom card printing',
    price: 'From $3',
    image: 'https://images.unsplash.com/photo-1607344645866-009c320b63e0?w=400&h=400&fit=crop',
  },
  {
    id: 6,
    name: 'Limited Editions',
    description: 'We specialize in tailored limited edition releases. We can create tired limited release packages, unique packages and bundles, special items, autographed items, and so much more. Let us drive your next special project to maximum success.',
    price: 'Custom pricing',
    image: '/images/clients/limited-editions.png',
  },
];

const Home = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-mint-300 to-mint-400 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-10 left-10 w-32 h-32 bg-white rounded-full"></div>
          <div className="absolute bottom-20 right-20 w-48 h-48 bg-white rounded-full"></div>
          <div className="absolute top-1/2 left-1/3 w-24 h-24 bg-white rounded-full"></div>
        </div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-32 relative">
          <div className="text-center">
            <img
              src={heroLogo}
              alt="MerchMint"
              className="h-32 md:h-48 w-auto mx-auto mb-8 drop-shadow-lg"
            />
            <h1 className="text-3xl md:text-5xl font-black text-purple-600 mb-6" style={{ WebkitTextStroke: '1.5px currentColor' }}>
              Your Merchandise, Minted to Perfection
            </h1>
            <p className="text-lg md:text-xl font-black text-purple-600/80 max-w-2xl mx-auto mb-8" style={{ WebkitTextStroke: '0.6px currentColor' }}>
              Full-service merchandise management and fulfillment for artists, musicians, and creators.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/quote"
                className="inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-semibold rounded-full text-white bg-purple-600 hover:bg-purple-700 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
              >
                Get Started
              </Link>
              <Link
                to="/clients"
                className="inline-flex items-center justify-center px-8 py-3 border-2 border-purple-600 text-base font-semibold rounded-full text-purple-600 bg-transparent hover:bg-purple-600 hover:text-white transition-all duration-200"
              >
                View Our Work
              </Link>
            </div>
          </div>
        </div>

        {/* Decorative wave */}
        <div className="absolute bottom-0 left-0 right-0">
          <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 120L60 110C120 100 240 80 360 70C480 60 600 60 720 65C840 70 960 80 1080 85C1200 90 1320 90 1380 90L1440 90V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0Z" fill="white"/>
          </svg>
        </div>
      </section>

      {/* Merchandise Showcase */}
      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              What We Create
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              From t-shirts to vinyl, we bring your merchandise vision to life with quality and care.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {products.map((product) => (
              <div
                key={product.id}
                className="group bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
              >
                <div className="aspect-square overflow-hidden bg-gray-100">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    {product.name}
                  </h3>
                  <p className="text-gray-600 mb-3">{product.description}</p>
                  <p className="text-lg font-bold text-mint-500">{product.price}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-purple-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Ready to Mint Your Merch?
          </h2>
          <p className="text-lg text-purple-100 max-w-2xl mx-auto mb-8">
            Join the artists and creators who trust MerchMint with their merchandise dreams.
          </p>
          <Link
            to="/quote"
            className="inline-flex items-center justify-center px-8 py-3 border-2 border-white text-base font-semibold rounded-full text-white hover:bg-white hover:text-purple-600 transition-all duration-200"
          >
            Get a Quote Today
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;
